import { gql } from 'glimmer-apollo';

export const ESPORTS_POST_QUERY = gql`
  query ($slug: String) {
    article: eSportsArticle(slug: $slug) {
      title
      slug
      shortDescription
      body
      publishedDate
      coverImage {
        url(width: 800, height: 500, fit: cover, format: webp)
      }
      author {
        name
        bio
        socialLinks {
          url
          platform
          accessibilityDescription
        }
        avatar {
          url(width: 80, height: 80, fit: cover, format: webp)
        }
      }
      match {
        isLive
        isFinal
        slug
        title
        scheduledDate
        rounds {
          victor {
            slug
          }
        }
        teams {
          name
          slug
          logo {
            url(width: 64, height: 64, fit: cover, format: webp)
          }
        }
        victor {
          slug
          name
          logo {
            url(width: 64, height: 64, fit: cover, format: webp)
          }
        }
      }
      tournament {
        isLive
        isFinal
        teams {
          name
          slug
          logo {
            url(width: 64, height: 64, fit: cover, format: webp)
          }
        }
        victor {
          slug
          name
          logo {
            url(width: 64, height: 64, fit: cover, format: webp)
          }
        }
      }
      relatedArticles {
        __typename
        title
        shortDescription
        slug
        publishedDate
        coverImage {
          url(width: 400, height: 250, fit: cover, format: webp)
        }
        author {
          name
          avatar {
            url(width: 60, height: 60, fit: cover, format: webp)
          }
        }
      }
    }
  }
`;
